import { useMutation } from 'react-query';
import { IProject } from '../../interfaces/project.interface';
import { baseApi, buildAuthHeaders, throwApiError, useRetrieveToken } from './shared';

export const useHabmapApi = () => {
  const { retrieveToken } = useRetrieveToken();

  const createInstantHabmap = useMutation(async (projectData: IProject) => {
    const token = await retrieveToken('createInstantHabmap');
    if (!token) return;

    const response = await fetch(`${baseApi}/instant-hab-map`, {
      method: 'POST',
      headers: buildAuthHeaders(token),
      body: JSON.stringify({ ...projectData, platformClient: true }),
    });

    if (!response.ok) await throwApiError(response, 'createInstantHabmap', { projectData });

    return response.json();
  });

  const generatePdfDownloadUrl = useMutation(async (s3Key: string) => {
    const token = await retrieveToken('generatePdfDownloadUrl');
    if (!token) return;

    const response = await fetch(`${baseApi}/instant-hab-map/download-url?key=${encodeURIComponent(s3Key)}`, {
      method: 'GET',
      headers: buildAuthHeaders(token),
    });

    if (!response.ok) await throwApiError(response, 'generatePdfDownloadUrl');

    return response.json();
  });

  const listDeliverables = useMutation(async (projectId: string) => {
    const token = await retrieveToken('listDeliverables');
    if (!token) return;

    const response = await fetch(
      `${baseApi}/instant-hab-map/deliverables?projectId=${encodeURIComponent(projectId)}`,
      {
        method: 'GET',
        headers: buildAuthHeaders(token),
      },
    );

    if (!response.ok) await throwApiError(response, 'listDeliverables', { projectId });

    return response.json() as Promise<{ files: string[] }>;
  });

  return {
    createInstantHabmap,
    generatePdfDownloadUrl,
    listDeliverables,
  };
};
